define([
    './WizardContentDirective',
    './WizardSidebarRibbonDirective',
    './WizardStepProgressDirective',
    './WizardPageActionsDirective',
    'angularRouter'
], (WizardContentDirective, WizardSidebarRibbonDirective, WizardStepProgressDirective, WizardPageActionsDirective)=> {
    return angular.module('edge.platform.widgets.wizard', ['edge.platform.base', 'ui.router'])
        .directive('gwWizardContent', WizardContentDirective)
        .directive('gwWizardSidebarRibbon', WizardSidebarRibbonDirective)
        .directive('gwWizardStepProgress', WizardStepProgressDirective)
        .directive('gwWizardPageActions', WizardPageActionsDirective);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/wizard/module.js
 **/